import RecipesList from './recipes-list';

export default class RecipesListDesktop extends RecipesList {
    constructor(...args) {
        super(...args);

        this._retrieveDOM();
        this._initRecipeListLayout();
    }

    _initRecipeListLayout() {
        this.recipeListPckry = new Packery( this.dom.views.recipeList, {
            // options
            //containerStyle: null,
            itemSelector: '.ct--recipe-item',
            // horizontal: true,
            percentPosition: true,
            gutter: 0
            //resize: false,
            //transitionDuration: 0
        });
    }

    _retrieveDOM() {
        this.dom.views = {};

        this.dom.views.recipeList = this.dom.page.querySelector('.js-recipe-list');
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/recipes/list/recipes-list.desktop.js